var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"name":"list","tag":"div"}},_vm._l((_vm.orders),function(order){return _c('order-list-item',{key:order.id,attrs:{"order":order,"add-to-cart-button-dependency":_vm.addToCartButtonDependency}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }